import ContentEntity from './content-entity.js';

/**
 * ServiceEntity — one community program / service page
 * (/services + /services/:slug). Service pages are section-driven: the
 * `sections` array renders through the section registry, so SECTION_TYPES
 * doubles as the authoring reference for valid `type` values.
 */
class ServiceEntity extends ContentEntity {
    static TYPE = 'services';
    static S3_PATH = 'content.servicesData';

    // Section `type` values understood by the service page renderer.
    static SECTION_TYPES = ['contentHero', 'grid', 'split', 'faq', 'cta', 'gallery'];

    static EMPTY = {
        id: '',
        categoryId: '',
        isActive: true,
        slug: '',
        name: '',
        seo: { title: '', description: '', keywords: '', image: '' },
        card: { title: '', description: '', image: '', buttonText: '' },
        hero: {
            label: '', title: '', subtitle: '', description: '',
            imageDesktop: '', imageMobile: '', buttonText: '', buttonHref: '',
        },
        sections: [],
        source: 'local',
        externalId: null,
    };

    constructor(raw = {}) {
        super(raw);
        const R = ServiceEntity.resolveImg;
        // Card/hero images may be authored as assets-data keys — resolve once here.
        if (raw.card) this.card = { ...raw.card, image: R(raw.card.image) };
        if (raw.hero) {
            this.hero = {
                ...raw.hero,
                imageDesktop: R(raw.hero.imageDesktop),
                imageMobile: R(raw.hero.imageMobile),
            };
        }
    }
}

export default ServiceEntity;
